import clsx from 'clsx';
import { LuPartyPopper } from 'react-icons/lu';

interface CelebrateProps {
  className?: string;
  color?: 'green' | 'white';
}

export const Celebrate = ({ className, color = 'green' }: CelebrateProps) => (
  <LuPartyPopper
    className={clsx(
      'w-12 h-12 animate-celebrate',
      color === 'green' && 'text-pt-primary',
      color === 'white' && 'text-white',
      className,
    )}
    aria-label="Celebrate"
  />
);
